import _slicedToArray from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var _excluded = ["sortOrder", "sortColumn"];
import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { getLocalTranslation, handleApiRequestSuccessData, handleRequestError } from '@jove-frontend/uikit';
import qs from 'qs';
import { api } from '.';
export var apiGetUsers = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var sortOrder, sortColumn, args, res, _err$response, _err$response$data, _err$response$data$de, _err$response$data$de2, message;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            sortOrder = _ref.sortOrder, sortColumn = _ref.sortColumn, args = _objectWithoutProperties(_ref, _excluded);
            _context.prev = 1;
            _context.next = 4;
            return api.get('/users', {
              params: _objectSpread({
                sort_order: sortOrder,
                sort_column: sortColumn
              }, args)
            });

          case 4:
            res = _context.sent;
            return _context.abrupt("return", [res.data]);

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            message = (_err$response = _context.t0.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : (_err$response$data$de = _err$response$data.detail) === null || _err$response$data$de === void 0 ? void 0 : (_err$response$data$de2 = _err$response$data$de[0]) === null || _err$response$data$de2 === void 0 ? void 0 : _err$response$data$de2.msg;
            console.error("Failed to fetch users because: ".concat(message));
            return _context.abrupt("return", [null, _context.t0]);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8]]);
  }));

  return function apiGetUsers(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export var apiGetUser = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(userId) {
    var res, _err$response2, _err$response2$data, _err$response2$data$d, _err$response2$data$d2, _err$response3, message;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;

            if (userId) {
              _context2.next = 3;
              break;
            }

            throw new Error("Invalid user id: ".concat(userId));

          case 3:
            _context2.next = 5;
            return api.get("/users/".concat(userId));

          case 5:
            res = _context2.sent;
            return _context2.abrupt("return", [res.data.data.user]);

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](0);
            message = (_err$response2 = _context2.t0.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : (_err$response2$data$d = _err$response2$data.detail) === null || _err$response2$data$d === void 0 ? void 0 : (_err$response2$data$d2 = _err$response2$data$d[0]) === null || _err$response2$data$d2 === void 0 ? void 0 : _err$response2$data$d2.msg;
            console.error("Failed to fetch user because: ".concat(message));

            if (((_err$response3 = _context2.t0.response) === null || _err$response3 === void 0 ? void 0 : _err$response3.status) === 401) {
              _context2.t0.message = 401;
            }

            return _context2.abrupt("return", [null, _context2.t0]);

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 9]]);
  }));

  return function apiGetUser(_x2) {
    return _ref3.apply(this, arguments);
  };
}();
export var apiCreateUser = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(payload) {
    var res, _err$response4, _err$response4$data, _err$response4$data$d, _err$response4$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return api.post("/users", payload);

          case 3:
            res = _context3.sent;
            return _context3.abrupt("return", [res.data.data.user]);

          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3["catch"](0);
            message = (_err$response4 = _context3.t0.response) === null || _err$response4 === void 0 ? void 0 : (_err$response4$data = _err$response4.data) === null || _err$response4$data === void 0 ? void 0 : (_err$response4$data$d = _err$response4$data.detail) === null || _err$response4$data$d === void 0 ? void 0 : (_err$response4$data$d2 = _err$response4$data$d[0]) === null || _err$response4$data$d2 === void 0 ? void 0 : _err$response4$data$d2.msg;
            console.error("Failed to create user because: ".concat(message));
            return _context3.abrupt("return", [null, _context3.t0]);

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 7]]);
  }));

  return function apiCreateUser(_x3) {
    return _ref4.apply(this, arguments);
  };
}();
export var apiCreateCommunityUser = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(auth0Id, payload) {
    var res, _err$response5, _err$response5$data, _err$response5$data$d, _err$response5$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;

            if (auth0Id) {
              _context4.next = 3;
              break;
            }

            throw new Error("Invalid auth0 id: ".concat(auth0Id));

          case 3:
            _context4.next = 5;
            return api.post("/users/".concat(auth0Id, "/community"), payload);

          case 5:
            res = _context4.sent;
            return _context4.abrupt("return", [res.data.data.user]);

          case 9:
            _context4.prev = 9;
            _context4.t0 = _context4["catch"](0);
            message = (_err$response5 = _context4.t0.response) === null || _err$response5 === void 0 ? void 0 : (_err$response5$data = _err$response5.data) === null || _err$response5$data === void 0 ? void 0 : (_err$response5$data$d = _err$response5$data.detail) === null || _err$response5$data$d === void 0 ? void 0 : (_err$response5$data$d2 = _err$response5$data$d[0]) === null || _err$response5$data$d2 === void 0 ? void 0 : _err$response5$data$d2.msg;
            console.error("Failed to create user because: ".concat(message));
            return _context4.abrupt("return", [null, _context4.t0]);

          case 14:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 9]]);
  }));

  return function apiCreateCommunityUser(_x4, _x5) {
    return _ref5.apply(this, arguments);
  };
}();
export var apiUpdateUser = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(userId, payload) {
    var res, _err$response6, _err$response6$data, _err$response6$data$d, _err$response6$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;

            if (userId) {
              _context5.next = 3;
              break;
            }

            throw new Error("Invalid user id: ".concat(userId));

          case 3:
            _context5.next = 5;
            return api.patch("/users/".concat(userId), payload);

          case 5:
            res = _context5.sent;
            return _context5.abrupt("return", [res.data.data.user]);

          case 9:
            _context5.prev = 9;
            _context5.t0 = _context5["catch"](0);
            message = (_err$response6 = _context5.t0.response) === null || _err$response6 === void 0 ? void 0 : (_err$response6$data = _err$response6.data) === null || _err$response6$data === void 0 ? void 0 : (_err$response6$data$d = _err$response6$data.detail) === null || _err$response6$data$d === void 0 ? void 0 : (_err$response6$data$d2 = _err$response6$data$d[0]) === null || _err$response6$data$d2 === void 0 ? void 0 : _err$response6$data$d2.msg;
            console.error("Failed to fetch user because: ".concat(message));
            return _context5.abrupt("return", [null, _context5.t0]);

          case 14:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 9]]);
  }));

  return function apiUpdateUser(_x6, _x7) {
    return _ref6.apply(this, arguments);
  };
}();
export function fetchAssigneeUsers(_x8) {
  return _fetchAssigneeUsers.apply(this, arguments);
}

function _fetchAssigneeUsers() {
  _fetchAssigneeUsers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref7) {
    var organizationId, organizationSlug, _yield$apiGetUsers, _yield$apiGetUsers2, res;

    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            organizationId = _ref7.organizationId, organizationSlug = _ref7.organizationSlug;
            _context9.next = 3;
            return apiGetUsers({
              organization_id: organizationId,
              organization_slug: organizationSlug
            });

          case 3:
            _yield$apiGetUsers = _context9.sent;
            _yield$apiGetUsers2 = _slicedToArray(_yield$apiGetUsers, 1);
            res = _yield$apiGetUsers2[0];
            return _context9.abrupt("return", new Promise(function (resolve) {
              var userList = ((res === null || res === void 0 ? void 0 : res.data) || []).map(function (i) {
                return {
                  value: i.user.id,
                  label: i.user.first_name + ' ' + i.user.last_name
                };
              });
              userList.push({
                value: null,
                label: 'Unassigned'
              });
              resolve(userList);
            }));

          case 7:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _fetchAssigneeUsers.apply(this, arguments);
}

export function fetchFilterUsers(_x9) {
  return _fetchFilterUsers.apply(this, arguments);
}

function _fetchFilterUsers() {
  _fetchFilterUsers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(args) {
    var _yield$apiGetUsers3, _yield$apiGetUsers4, res, users, userList;

    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return apiGetUsers(args);

          case 2:
            _yield$apiGetUsers3 = _context10.sent;
            _yield$apiGetUsers4 = _slicedToArray(_yield$apiGetUsers3, 1);
            res = _yield$apiGetUsers4[0];
            users = res === null || res === void 0 ? void 0 : res.data;
            userList = [];

            if (users) {
              userList = users.map(function (user) {
                return {
                  value: user.user.id,
                  label: user.user.first_name + ' ' + user.user.last_name,
                  checked: false
                };
              });
            }

            userList = userList.sort(function (a, b) {
              return a.label.localeCompare(b.label);
            });
            userList.unshift({
              value: 'Unassigned',
              label: getLocalTranslation().$t('kit:unassigned'),
              checked: false
            });
            return _context10.abrupt("return", userList);

          case 11:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _fetchFilterUsers.apply(this, arguments);
}

export var apiUploadUpdateUserAvatar = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return api.post("/users/avatar", payload.formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });

          case 3:
            res = _context6.sent;
            return _context6.abrupt("return", [res.data]);

          case 7:
            _context6.prev = 7;
            _context6.t0 = _context6["catch"](0);
            return _context6.abrupt("return", handleRequestError(_context6.t0, payload));

          case 10:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 7]]);
  }));

  return function apiUploadUpdateUserAvatar(_x10) {
    return _ref8.apply(this, arguments);
  };
}();
export var apiCheckUserAuthPermission = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            _context7.next = 3;
            return api.get("/admin/quotes/broker/user/quote-edit-permission?".concat(qs.stringify(payload)));

          case 3:
            res = _context7.sent;
            handleApiRequestSuccessData(res);
            return _context7.abrupt("return", [res.data]);

          case 8:
            _context7.prev = 8;
            _context7.t0 = _context7["catch"](0);
            return _context7.abrupt("return", handleRequestError(_context7.t0));

          case 11:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[0, 8]]);
  }));

  return function apiCheckUserAuthPermission(_x11) {
    return _ref9.apply(this, arguments);
  };
}();
export var apiCheckUserAuthRegisterInformation = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;
            _context8.next = 3;
            return api.get("/users/website/user-check?".concat(qs.stringify(payload)));

          case 3:
            res = _context8.sent;
            handleApiRequestSuccessData(res);
            return _context8.abrupt("return", [res.data]);

          case 8:
            _context8.prev = 8;
            _context8.t0 = _context8["catch"](0);
            return _context8.abrupt("return", handleRequestError(_context8.t0));

          case 11:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[0, 8]]);
  }));

  return function apiCheckUserAuthRegisterInformation(_x12) {
    return _ref10.apply(this, arguments);
  };
}();